import { withTranslation } from 'react-i18next';
import Footer from './Footer.style';

export default withTranslation()(Footer);
